import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SummaryApi from '../common'
import { MdDelete, MdVerifiedUser, MdClose } from "react-icons/md";
import displayINRCurrency from '../helpers/displayCurrency';
import VerticalCardProduct from '../components/VerticalCardProduct';
import addToCart from '../helpers/addToCart';
import Context from '../context';
// import { dummyProducts } from '../helpers/dummyData';
import wishlistHelper from '../helpers/wishlistHelper';
import { FaStar, FaRegHeart, FaHeart, FaWhatsapp, FaBalanceScale, FaTruck, FaQrcode, FaAngleRight, FaPlus, FaMinus, FaRegUserCircle, FaCheckCircle, FaFlask, FaBug, FaLeaf, FaShieldAlt, FaInfoCircle, FaBox, FaTag, FaMicroscope } from "react-icons/fa";
import service from '../common/HttpService';
import { motion, AnimatePresence } from 'framer-motion';
import { getCookie } from '../common/cookieHelper';
import useTranslate from '../hooks/useTranslate';
import { trackContact } from '../helpers/analyticsHelper';


const ProductDetails = () => {
    const [data, setData] = useState({
        _id: "",
        productName: "",
        brandName: "",
        category: "",
        subcategory_name: "",
        productImage: [],
        description: "",
        ingredients: "",
        nutritional_value: "",
        price: "",
        sellingPrice: "",
        item_rates: [],
        formulation: "",
        chemical_composition: "",
        technicalName: "",
        targetPest: "",
        dosage: "",
        suitableCrops: "",
        safetyPrecautions: "",
        productKnowledge: "",
        product_code: "",
        ratings: []
    })
    const params = useParams()
    const [loading, setLoading] = useState(true)
    const [activeImage, setActiveImage] = useState("")

    const toxicityMap = {
        'Insecticides': { label: 'Extremely Toxic', color: '#ef4444', text: '#dc2626', code: 'Ib', bg: 'bg-red-500', textColor: 'text-red-600', warning: 'POISON', subtext: 'Keep out of reach of children.' },
        'Fungicides': { label: 'Highly Toxic', color: '#fbbf24', text: '#d97706', code: 'II', bg: 'bg-yellow-400', textColor: 'text-yellow-600', warning: 'POISON', subtext: 'Harmful if swallowed.' },
        'Herbicides': { label: 'Moderately Toxic', color: '#3b82f6', text: '#2563eb', code: 'III', bg: 'bg-blue-500', textColor: 'text-blue-600', warning: 'DANGER', subtext: 'Avoid contact with skin.' },
        'Seeds': { label: 'Non-Toxic', color: '#10b981', text: '#059669', code: 'IV', bg: 'bg-green-500', textColor: 'text-green-600', warning: 'CAUTION', subtext: 'Handle with care.' },
        'Crop Nutrition': { label: 'Slightly Toxic', color: '#10b981', text: '#059669', code: 'IV', bg: 'bg-green-500', textColor: 'text-green-600', warning: 'CAUTION', subtext: 'Safe for general use.' },
    }
    const tox = toxicityMap[data?.category] || toxicityMap['Seeds']
    const [zoomImageCoordinate, setZoomImageCoordinate] = useState({ x: 0, y: 0 })
    const [zoomImage, setZoomImage] = useState(false)
    const [selectedVariant, setSelectedVariant] = useState(null)
    const [localQuantity, setLocalQuantity] = useState(1)
    const [activeFaq, setActiveFaq] = useState(null)
    const [activeDetail, setActiveDetail] = useState("description")
    const [isSizeGuideModalOpen, setIsSizeGuideModalOpen] = useState(false)
    const { translateText, languageCode } = useContext(Context);

    const t = useTranslate({
        home: "Home",
        goBack: "Go Back",
        save: "SAVE",
        off: "OFF",
        qualityGuaranteed: "Quality Guaranteed",
        exclusiveOffer: "Exclusive Offer: Get it for",
        productName: "Product Name",
        category: "Category",
        chemicalComposition: "Chemical Composition",
        formulation: "Formulation",
        targetPest: "Target Pest",
        recommendedDosage: "Recommended Dosage",
        dosage: "Dosage / Dose",
        suitableCrops: "Suitable Crops",
        technicalName: "Technical Name",
        nutritionalFacts: "Nutritional Facts",
        safetyPrecautions: "Safety Precautions",
        selectSize: "Select Size",
        sizeGuide: "Size Guide",
        bestSeller: "BEST SELLER",
        addToCart: "Add To Cart",
        buyNow: "Buy Now",
        goToCart: "Go to Cart",
        overview: "Overview",
        subCategory: "Sub Category",
        aboutProduct: "About Product",
        productDescription: "PRODUCT Description",
        specifications: "SPECIFICATIONS",
        productNotFound: "Product Not Found",
        productNotFoundDesc: "The product you are looking for does not exist or has been removed from our catalog.",
        backToShopping: "Back to Shopping",
        farmersBought: "Farmers bought this month",
        longerExpiry: "Longer Expiry",
        fastDelivery: "Fast Delivery",
        qrVerified: "QR Verified",
        similarProducts: "Similar Growth Promoters",
        limitedOffer: "Limited Offer",
        bookNow: "Book Now",
        poison: "POISON",
        danger: "DANGER",
        caution: "CAUTION",
        bestPrice: "Best Price",
        brand: "Brand",
        // subCategory: "Sub Category",
        customerReviews: "Customer Reviews",
        verifiedCommunityRatings: "Verified Community Ratings",
        reviewProduct: "Review this product",
        shareThoughts: "Share your thoughts with other farmers",
        writeReview: "Write a Product Review",
        topVerified: "Top Verified Reviews",
        verifiedFarmer: "Verified Farmer",
        reviewedOn: "Reviewed On",
        productFaqs: "Product FAQs",
        specialOffer: "Special Offer",
        exclusiveDiscounts: "EXCLUSIVE DISCOUNTS FOR OUR FARMERS",
        activeNow: "Active Now",
        extraOff: "Extra 5% OFF",
        whatsappOfferDesc: "Get an additional 5% discount on this product when you order via WhatsApp or Online Payment.",
        copyCode: "Copy Code",
        freeShipping: "Free Shipping",
        freeShippingDesc: "Valid on all prepaid orders today. No minimum value required.",
        qualityAssurance: "Quality Assurance",
        qualityAssuranceDesc: "100% Genuine products with easy replacement policy.",
        applyOffer: "Apply Offer",
        sizeGuideHeader: "AGRICULTURAL MEASUREMENT STANDARDS",
        unit: "Unit",
        application: "Application",
        solidsDesc: "Solids, Granules, Powder products",
        liquidsDesc: "Liquids, Emulsions, Soluble concentrates",
        seedsDesc: "Seeds and pre-measured small doses",
        coverageDesc: "Coverage area estimation per unit",
        sizeInfoDesc: "Selecting the right size depends on your land area. Generally, 5-8kg is sufficient for 1 Acre basal application for most field crops.",
        gotIt: "Got It",
        star: "star",
        technicalDetails: "Technical Content Details",
        deliveringTo: "Delivering To:",
        projectFasal: "Project Fasal",
        farmersBoughtCount: "750+",
        totalAmount: "Total Amount"
    });

    const [translatedData, setTranslatedData] = useState(null)
    const [translatedToxicity, setTranslatedToxicity] = useState(null)
    const [translatedFaqs, setTranslatedFaqs] = useState([])
    const [translatedReviews, setTranslatedReviews] = useState([])
    const [translatedSimilarHeading, setTranslatedSimilarHeading] = useState("Similar Growth Promoters")

    const { fetchUserAddToCart, cartItems, fetchUserWishlist, setShowCheckout, setCheckoutData, setShowCart } = useContext(Context)
    const user = useSelector(state => state?.user?.user)
    const navigate = useNavigate()

    const cartItem = cartItems?.find(item => {
        const itemProdId = String(item.productId?._id || item.productId?.id || item.product_id || item.productId || "");
        const currentProdId = String(params?.id || data?._id || data?.id || "");
        const matchesProduct = itemProdId === currentProdId && itemProdId !== "";

        if (!matchesProduct) return false;

        if (selectedVariant) {
            const itemRateId = String(
                item.item_rate?.[0]?.id ||
                item.item_rates?.[0]?.id ||
                item.rate_id ||
                item.item_rate_id ||
                item.selectedRate?.id ||
                ""
            );
            const currentRateId = String(selectedVariant);
            if (itemRateId && currentRateId) {
                return itemRateId === currentRateId;
            }
        }
        return true;
    });

    const allProductRates = useMemo(() => {
        const rawRates = (Array.isArray(data?.item_rates) && data.item_rates.length > 0)
            ? data.item_rates
            : ((Array.isArray(data?.item_rate) && data.item_rate.length > 0)
                ? data.item_rate
                : (Array.isArray(data?.rates) ? data.rates : []));

        const cartRate = (cartItem?.item_rate && cartItem.item_rate[0]) || (cartItem?.item_rates && cartItem.item_rates[0]) || {};
        const fallbackShipping = cartRate.shipping_charges || cartRate.shipping_charge || cartItem?.shipping_charges || cartItem?.shipping_charge || data?.shipping_charges || data?.shipping_charge || 0;

        return rawRates.map(r => ({
            ...r,
            shipping_charges: r.shipping_charges || r.shipping_charge || fallbackShipping,
            shipping_charge: r.shipping_charge || r.shipping_charges || fallbackShipping
        }));
    }, [data, cartItem]);

    const activeRate = allProductRates.find(r => String(r.id) === String(selectedVariant)) || allProductRates[0] || {}
    const currentSellingPrice = Number(activeRate.salerate) || data?.sellingPrice || 0
    const currentMRP = Number(activeRate.mrp) || data?.price || 0
    const totalPrice = currentSellingPrice * localQuantity

    const handleWishlist = (e, product) => {
        const userId = user?._id || user?.id || user?.user_id || getCookie('user_id');
        if (!userId) {
            navigate("/login")
            return
        }
        wishlistHelper.addToWishlist(e, product)
        fetchUserWishlist()
    }

    const isInCart = !!cartItem

    const quantity = cartItem?.quantity || 1
    const isDummy = cartItem?.isDummy || params?.id?.startsWith('dummy') || params?.id?.startsWith('f') || params?.id?.startsWith('h')
    const cartId = cartItem ? ((cartItem.cart_id && !isNaN(Number(cartItem.cart_id))) ? cartItem.cart_id : ((cartItem.id && !isNaN(Number(cartItem.id))) ? cartItem.id : (cartItem.id || cartItem.cart_id || cartItem._id))) : null
    const dummyId = cartItem?.dummyId || params?.id

    // const updateQty = async (id, qty, isDummy, dummyId, change) => {
    //     if (isDummy) {
    //         let cart = JSON.parse(localStorage.getItem('dummyCart')) || []
    //         const item = cart.find(i => i.productId === dummyId)
    //         if (item) {
    //             if (change === -1 && item.quantity === 1) {
    //                 cart = cart.filter(i => i.productId !== dummyId)
    //             } else {
    //                 item.quantity += change
    //             }
    //             localStorage.setItem('dummyCart', JSON.stringify(cart))
    //             fetchUserAddToCart()
    //         }
    //         return
    //     }

    //     const newQty = qty + change
    //     const userId = user?._id || user?.id || user?.user_id || getCookie('user_id')
    //     if (newQty <= 0) {
    //         const responseData = await service.post(SummaryApi.delete_cart.url, {
    //             id: id,
    //             user_id: userId
    //         })
    //         if (responseData.success === "true" || responseData.success === true) { fetchUserAddToCart() }
    //     } else {
    //         const responseData = await service.post(SummaryApi.update_cart.url, {
    //             id: id,
    //             qty: newQty,
    //             user_id: userId
    //         })
    //         if (responseData.success === "true" || responseData.success === true) { fetchUserAddToCart() }
    //     }
    // }

    const fetchProductDetails = useCallback(async () => {
        try {
            setLoading(true)
            // Fetch product by ID using POST and form payload
            const response = await service.post(SummaryApi.productDetails.url || "https://admin.fasalshop.com/Api/product_by_id", { id: params?.id })

            if (response?.success === true || response?.success === "true") {
                const rawProdList = Array.isArray(response.extraData?.product) ? response.extraData.product : (Array.isArray(response.data) ? response.data : [response.extraData?.product || response.extraData || response]);

                const rawProd = rawProdList[0] || rawProdList;

                if (rawProd) {
                    const allRawRates = (Array.isArray(rawProd?.item_rates) && rawProd.item_rates.length > 0)
                        ? rawProd.item_rates
                        : ((Array.isArray(rawProd?.item_rate) && rawProd.item_rate.length > 0)
                            ? rawProd.item_rate
                            : (Array.isArray(rawProd?.rates) ? rawProd.rates : []));
                    const mainRate = allRawRates[0] || {};
                    const backendBaseUrl = "https://admin.fasalshop.com";

                    // Robust image extraction focusing on the 'image' array from the provided JSON
                    let images = [];
                    if (Array.isArray(rawProd.image)) {
                        images = rawProd.image;
                    } else if (typeof rawProd.image === 'string' && rawProd.image) {
                        images = rawProd.image.includes(',') ? rawProd.image.split(',') : [rawProd.image];
                    } else if (Array.isArray(rawProd.productImage)) {
                        images = rawProd.productImage;
                    }

                    // Base URL prepending if path is relative
                    images = images.map(img => {
                        if (typeof img === 'string' && img && !img.startsWith('http')) {
                            const cleanPath = img.startsWith('/') ? img.substring(1) : img;
                            return `${backendBaseUrl}/${cleanPath}`;
                        }
                        return img;
                    }).filter(Boolean);

                    if (images.length === 0) {
                        images = ["https://placehold.co/400x400/eaeff6/2a4b7c?text=Images+Coming+Soon"];
                    }

                    const mappedData = {
                        ...rawProd,
                        _id: rawProd.id || rawProd._id,
                        productName: rawProd.itemname || rawProd.productName || "-",
                        category: rawProd.category_name || rawProd.category || "-",
                        brandName: rawProd.brand_name || rawProd.brandName || rawProd.vendor_name || "-",
                        subcategory_name: rawProd.subcategory_name || rawProd.subcategory || "-",
                        productImage: images,
                        description: rawProd.disc || rawProd.description || "-",
                        ingredients: rawProd.ingredients || "-",
                        nutritional_value: rawProd.nutritional_facts || rawProd.nutritional_value || rawProd.nutritional_val || "-",
                        price: Number(mainRate.mrp) || Number(rawProd.price) || 0,
                        sellingPrice: Number(mainRate.salerate) || Number(rawProd.sellingPrice) || 0,
                        shipping_charges: mainRate.shipping_charges || mainRate.shipping_charge || rawProd.shipping_charges || rawProd.shipping_charge || rawProd.delivery_charge || rawProd.delivery_charges || 0,
                        shipping_charge: mainRate.shipping_charge || mainRate.shipping_charges || rawProd.shipping_charge || rawProd.shipping_charges || rawProd.delivery_charge || rawProd.delivery_charges || 0,
                        item_rates: allRawRates,
                        item_rate: allRawRates,
                        rates: allRawRates,
                        formulation: rawProd.formulation || rawProd.formula || "-",
                        chemical_composition: rawProd.chemical_composition || "-",
                        technicalName: rawProd.technical_name || rawProd.technicalName || "-",
                        product_code: rawProd.product_code || rawProd.productCode || "-",
                        targetPest: rawProd.target_pest || rawProd.targetPests || rawProd.targetPest || "-",
                        dosage: rawProd.dose || rawProd.recommended_dosage || rawProd.dosage || "-",
                        suitableCrops: rawProd.suitable_crops || rawProd.suitableCrop || rawProd.suitableCrops || "-",
                        safetyPrecautions: rawProd.safety_precautions || rawProd.safetyPrecautions || "-",
                        productKnowledge: rawProd.product_knowledge || rawProd.productKnowledge || rawProd.disc || rawProd.description || "-",
                        ratings: rawProd.ratings || []
                    };

                    setData(mappedData)
                    setActiveImage(mappedData.productImage[0])
                    if (allRawRates && allRawRates.length > 0) {
                        setSelectedVariant(allRawRates[0].id)
                    }
                    setLoading(false)
                } else {
                    setData(null)
                    setLoading(false)
                }
            } else {
                setData(null)
                setLoading(false)
            }
        } catch (error) {
            console.log("Error fetching product details:", error)
            setData(null)
            setLoading(false)
        }
    }, [params?.id])

    useEffect(() => {
        window.scrollTo(0, 0)
        fetchProductDetails()
    }, [fetchProductDetails])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [params?.id])

    // Save to Recently Viewed
    useEffect(() => {
        if (data?._id && !loading) {
            const stored = localStorage.getItem('recentlyViewed')
            let viewedItems = stored ? JSON.parse(stored) : []

            // Remove if already exists to move to top
            viewedItems = viewedItems.filter(item => item._id !== data._id)

            // Add current product
            viewedItems.push({
                _id: data?._id,
                productName: data?.productName,
                category: data?.category,
                productImage: data?.productImage,
                sellingPrice: data?.sellingPrice,
                price: data?.price
            })

            // Keep only last 10
            if (viewedItems.length > 10) {
                viewedItems.shift()
            }

            localStorage.setItem('recentlyViewed', JSON.stringify(viewedItems))
        }
    }, [data?._id, data?.productName, data?.category, data?.productImage, data?.sellingPrice, data?.price, loading])

    const handleMouseEnterProduct = (imageURL) => {
        setActiveImage(imageURL)
    }

    const handleZoomImage = useCallback((e) => {
        setZoomImage(true)
        const { left, top, width, height } = e.target.getBoundingClientRect()
        const x = (e.clientX - left) / width
        const y = (e.clientY - top) / height
        setZoomImageCoordinate({ x, y })
    }, [])

    const handleLeaveImageZoom = () => {
        setZoomImage(false)
    }

    const handleAddToCart = async (e) => {
        const userId = user?._id || user?.id || user?.user_id || getCookie('user_id');
        if (!userId) {
            navigate("/login")
            return
        }
        await addToCart(e, data, userId, selectedVariant || "", localQuantity)
        fetchUserAddToCart()
    }

    const handleBuyProduct = async (e, id) => {
        const userId = user?._id || user?.id || user?.user_id || getCookie('user_id');
        if (!userId) {
            navigate("/login")
            return
        }
        const currentActiveRate = allProductRates.find(r => String(r.id) === String(selectedVariant)) || allProductRates[0] || {};
        const rateIdToUse = selectedVariant || currentActiveRate?.id || "";

        const cartResult = await addToCart(e, data, userId, rateIdToUse, localQuantity)
        if (cartResult && !cartResult.error) {
            const updatedCart = await fetchUserAddToCart()
            const latestCartList = Array.isArray(updatedCart) ? updatedCart : cartItems;
            const matchedCartItem = latestCartList?.find(it => {
                const itProdId = String(it.productId?._id || it.productId?.id || it.product_id || it.productId || "");
                const curProdId = String(data?._id || data?.id || id || params?.id || "");
                return itProdId === curProdId && itProdId !== "";
            });
            const matchedRate = (matchedCartItem?.item_rate && matchedCartItem.item_rate[0]) || (matchedCartItem?.item_rates && matchedCartItem.item_rates[0]) || {};
            const shippingToUse = currentActiveRate?.shipping_charges || currentActiveRate?.shipping_charge || matchedRate?.shipping_charges || matchedRate?.shipping_charge || matchedCartItem?.shipping_charges || matchedCartItem?.shipping_charge || data?.shipping_charges || data?.shipping_charge || 0;

            const selectedRateWithShipping = {
                ...currentActiveRate,
                shipping_charges: shippingToUse,
                shipping_charge: shippingToUse
            };

            setCheckoutData({
                productId: data,
                quantity: localQuantity,
                rate_id: rateIdToUse,
                selectedRate: selectedRateWithShipping,
                shipping_charges: shippingToUse,
                shipping_charge: shippingToUse
            })
            setShowCheckout(true)
        }
    }

    const toggleFaq = (index) => {
        setActiveFaq(activeFaq === index ? null : index)
    }

    const toggleProductDetail = (section) => {
        setActiveDetail(activeDetail === section ? null : section)
    }

    const reviewMetrics = [
        { stars: 5, percent: 70 },
        { stars: 4, percent: 20 },
        { stars: 3, percent: 5 },
        { stars: 2, percent: 3 },
        { stars: 1, percent: 2 },
    ]

    const variants = allProductRates.length > 0 ? allProductRates.map((rate, index) => ({
        id: rate.id,
        size: `${rate.qty} ${rate.unit_name || rate.uom || (t.unit || 'Unit')}`,
        price: parseFloat(rate.salerate) || parseFloat(rate.mrp),
        originalPrice: parseFloat(rate.mrp),
        discount: parseFloat(rate.mrp) > parseFloat(rate.salerate) ? `${Math.round(((rate.mrp - rate.salerate) / rate.mrp) * 100)}% ${t.off || 'OFF'}` : t.bestPrice || 'Best Price',
        bestSeller: index === 0
    })) : []

    // Agricultural FAQs (Restored dummy data as requested)
    const faqs = [
        {
            question: "What is Biovita Liquid Biofertilizer used for?",
            answer: "It is a premium organic biofertilizer that improves plant growth, nutrient uptake, and stress tolerance."
        },
        {
            question: "Which crops can Biovita Liquid Biofertilizer be used on?",
            answer: "It can be used on all major crops including wheat, rice, corn, vegetables, and fruit plants."
        },
        {
            question: "Does Biovita Liquid Biofertilizer help with pest or disease control?",
            answer: "While its primary role is nourishment, it significantly strengthens the plant's natural immunity against common pests."
        },
        {
            question: "What are the benefits of using Biovita Liquid Biofertilizer?",
            answer: "Enhanced yield, better nutrient absorption, and improved soil microbial activity."
        },
        {
            question: "What is Biovita technical name?",
            answer: "It is a seaweed-based organic formulation rich in natural PGRs and micronutrients."
        },
        {
            question: "What is the recommended Biovita liquid dosage per litre?",
            answer: "The standard dose is 2-3 ml per litre of water for foliar spray."
        },
        {
            question: "When should Biovita Liquid Biofertilizer be applied?",
            answer: "Application is recommended at vegetative growth and flowering stages."
        }
    ]

    // Reviews from API falling back to dummy data (Restored as requested)
    const reviews = data?.ratings?.length > 0 ? data?.ratings?.map(r => ({
        id: r.id || r._id,
        user: r.user_name || r.user || "Farmer",
        sub: r.location || r.village || "Verified User",
        rating: Number(r.rating) || 5,
        comment: r.comment || r.review || "",
        date: r.date || "Recently",
        verified: true
    })) : [
        { id: 1, user: "Mahesh Nath", sub: "Verified Farmer", rating: 4, comment: "I've been using this for my wheat crop and the results are amazing. Much better than other brands.", date: "18 February 2026", verified: true },
        { id: 2, user: "Suman BigHaat", sub: "Farmer", rating: 5, comment: "Best quality organic fertilizer I've found on FasalShop. Highly recommended for vegetable crops.", date: "18 February 2026", verified: true },
        { id: 3, user: "Ramesh kudi", sub: "Progressive Farmer", rating: 4, comment: "Value for money. The plants look much healthier after just one spray.", date: "18 February 2026", verified: true },
        { id: 4, user: "Gopi Krishna", sub: "Organic Enthusiast", rating: 4, comment: "Solid product. Shipping was fast too.", date: "18 February 2026", verified: true }
    ]

    // Translation Effects
    useEffect(() => {
        const translateDataFields = async () => {
            if (!data?._id || !languageCode || languageCode === 'en') {
                setTranslatedData(data);
                return;
            }
            try {
                const fieldsToTranslate = [
                    'productName', 'category', 'brandName', 'subcategory_name',
                    'description', 'ingredients', 'nutritional_value', 'formulation',
                    'chemical_composition', 'technicalName', 'targetPest', 'dosage',
                    'suitableCrops', 'safetyPrecautions', 'productKnowledge'
                ];
                const translated = { ...data };
                await Promise.all(fieldsToTranslate.map(async (field) => {
                    if (data[field] && data[field] !== "-") {
                        translated[field] = await translateText(data[field], languageCode);
                    }
                }));
                setTranslatedData(translated);
            } catch (error) {
                console.error("Product translation error:", error);
                setTranslatedData(data);
            }
        };
        translateDataFields();
    }, [data, languageCode, translateText]);

    useEffect(() => {
        const translateTox = async () => {
            const currentTox = toxicityMap[data?.category] || toxicityMap['Seeds'];
            if (!languageCode || languageCode === 'en') {
                setTranslatedToxicity(currentTox);
                return;
            }
            try {
                setTranslatedToxicity({
                    ...currentTox,
                    label: await translateText(currentTox.label, languageCode),
                    warning: await translateText(currentTox.warning, languageCode),
                    subtext: await translateText(currentTox.subtext, languageCode)
                });
            } catch (error) {
                setTranslatedToxicity(currentTox);
            }
        };
        translateTox();
    }, [data?.category, languageCode, translateText]);

    useEffect(() => {
        const translateFaqList = async () => {
            if (!languageCode || languageCode === 'en') {
                setTranslatedFaqs(faqs);
                return;
            }
            const translated = await Promise.all(faqs.map(async f => ({
                question: await translateText(f.question, languageCode),
                answer: await translateText(f.answer, languageCode)
            })));
            setTranslatedFaqs(translated);
        };
        translateFaqList();
    }, [languageCode, translateText]);

    useEffect(() => {
        const translateReviewList = async () => {
            if (!languageCode || languageCode === 'en') {
                setTranslatedReviews(reviews);
                return;
            }
            const translated = await Promise.all(reviews.map(async r => ({
                ...r,
                comment: await translateText(r.comment, languageCode),
                sub: await translateText(r.sub, languageCode)
            })));
            setTranslatedReviews(translated);
        };
        translateReviewList();
    }, [languageCode, translateText]);

    useEffect(() => {
        const translateOthers = async () => {
            if (!languageCode || languageCode === 'en') {
                setTranslatedSimilarHeading("Similar Growth Promoters");
                return;
            }
            setTranslatedSimilarHeading(await translateText("Similar Growth Promoters", languageCode));
        };
        translateOthers();
    }, [languageCode, translateText]);

    const activeTox = translatedToxicity || toxicityMap[data?.category] || toxicityMap['Seeds'];
    const p = translatedData || data;

    const multiPacks = [] // No dummy packs as requested


    if (!data && !loading) {
        return (
            <div className='bg-[#f4f7f5] flex flex-col items-center justify-center p-6 text-center'>
                <div className='w-full max-w-sm mb-8'>
                    <img
                        src="https://cdni.iconscout.com/illustration/premium/thumb/search-not-found-6275834-5210416.png"
                        alt="Not Found"
                        className='w-full h-auto opacity-90'
                    />
                </div>
                <h2 className='text-3xl font-black text-[#143d2c] mb-4 uppercase'>{t.productNotFound}</h2>
                <p className='text-gray-400 text-lg mb-10 max-w-md mx-auto'>
                    {t.productNotFoundDesc}
                </p>
                <button
                    onClick={() => navigate("/")}
                    className='bg-[#00b259] hover:bg-[#143d2c] text-white font-black py-4 px-10 rounded-2xl shadow-xl transition-all active:scale-95 text-sm uppercase tracking-widest'
                >
                    {t.backToShopping}
                </button>
            </div>
        )
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className='bg-[#f4f7f5] min-h-screen py-4 lg:py-6 pt-4 lg:pt-6 transition-colors duration-500'
        >
            <div className='container mx-auto px-4'>

                {/* Navigation / Breadcrumb */}
                <div className='flex items-center justify-between mb-6'>
                    <div className='flex items-center gap-2 text-[11px] font-black uppercase tracking-widest text-slate-400'>
                        <Link to="/" className='hover:text-[#00b259] transition-colors'>{t.home}</Link>
                        <FaAngleRight size={10} />
                        <Link to={`/product-category?category=${data?.category}`} className='hover:text-[#00b259] transition-colors'>{p?.category}</Link>
                        <FaAngleRight size={10} />
                        <span className='text-[#00b259] truncate max-w-[100px] md:max-w-none'>{p?.productName}</span>
                    </div>
                    <button
                        onClick={() => navigate(-1)}
                        className='flex items-center gap-2 text-slate-500 hover:text-[#00b259] transition-all group'
                    >
                        <div className='w-8 h-8 rounded-full bg-white shadow-sm flex items-center justify-center group-hover:bg-[#00b259] group-hover:text-white transition-all'>
                            <FaAngleRight className='rotate-180' />
                        </div>
                        <span className='text-[10px] font-black uppercase tracking-widest hidden md:block'>{t.goBack}</span>
                    </button>
                </div>

                <div className='bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden'>
                    <div className='flex flex-col lg:flex-row p-3 lg:p-6 gap-6 lg:gap-10'>

                        {/* LEFT: IMAGE SECTION */}
                        <div className='lg:w-1/2 flex flex-col gap-4'>
                            <div className='relative bg-[#f8fcf9] rounded-3xl p-4 border border-gray-50 flex items-center justify-center min-h-[300px] lg:min-h-[450px] overflow-hidden group'>
                                <div className='absolute top-6 right-6 flex flex-col gap-4 z-10'>
                                    <button
                                        className={`p-3.5 rounded-2xl shadow-xl transition-all duration-300 border-2 ${wishlistHelper.isInWishlist(data?._id) ? 'bg-[#ff4757] text-white border-[#ff4757]' : 'bg-white/90 text-gray-400 hover:text-[#ff4757] border-white'}`}
                                        onClick={(e) => handleWishlist(e, data)}
                                    >
                                        {wishlistHelper.isInWishlist(data?._id) ? <FaHeart size={24} /> : <FaRegHeart size={24} />}
                                    </button>
                                    <a
                                        href={`https://wa.me/916266761336?text=${encodeURIComponent(`Hello FasalShop Support, I am interested in ${data?.productName || 'this product'}.`)}`}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        onClick={() => trackContact({ method: 'WhatsApp', content_name: data?.productName, location: 'Product Details Floating Button' })}
                                        className='bg-white/90 p-3.5 rounded-2xl shadow-xl text-[#25D366] hover:scale-110 hover:shadow-xl transition-all border-2 border-white flex items-center justify-center'
                                        title='Enquire on WhatsApp'
                                    >
                                        <FaWhatsapp size={24} />
                                    </a>
                                </div>

                                {loading ? (
                                    <div className='w-full h-full bg-slate-50 animate-pulse rounded-2xl'></div>
                                ) : (
                                    <div className='relative w-full h-full flex items-center justify-center overflow-hidden rounded-2xl'>
                                        <img
                                            src={activeImage}
                                            className='max-h-[350px] lg:max-h-[450px] object-contain mix-blend-multiply cursor-crosshair transform transition-transform duration-700'
                                            onMouseMove={handleZoomImage}
                                            onMouseLeave={handleLeaveImageZoom}
                                            alt={p?.productName}
                                        />
                                        {zoomImage && (
                                            <div className='hidden lg:block absolute inset-0 bg-white pointer-events-none z-20 border shadow-2xl rounded-2xl'>
                                                <div className='w-full h-full scale-[2.5]' style={{ backgroundImage: `url(${activeImage})`, backgroundRepeat: 'no-repeat', backgroundPosition: `${zoomImageCoordinate.x * 100}% ${zoomImageCoordinate.y * 100}%` }}></div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className='absolute bottom-6 left-6 flex flex-col items-center gap-1.5 opacity-90 scale-90 lg:scale-100'>
                                    <div className='bg-white text-[#00b259] p-3 rounded-2xl shadow-xl ring-1 ring-gray-100'><MdVerifiedUser size={32} /></div>
                                    <span className='text-[10px] font-black text-[#143d2c] uppercase tracking-[2px] bg-white/80 backdrop-blur-sm px-2 py-0.5 rounded-full'>{t.projectFasal}</span>
                                </div>
                            </div>

                            <div className='flex gap-2 overflow-x-auto scrollbar-none py-2 px-1'>
                                {loading ? [1, 2, 3, 4].map(i => <div key={i} className='min-w-[70px] h-20 bg-slate-50 rounded-xl animate-pulse'></div>) : data?.productImage?.map((imgURL) => (
                                    <div key={imgURL} className={`min-w-[70px] h-20 bg-white border-2 rounded-xl p-1.5 cursor-pointer transition-all duration-300 ${activeImage === imgURL ? 'border-[#00b259] shadow-md -translate-y-1' : 'border-gray-50 hover:border-gray-200 shadow-sm'}`} onMouseEnter={() => handleMouseEnterProduct(imgURL)}>
                                        <img src={imgURL} className='w-full h-full object-contain mix-blend-multiply' alt='thumbnail' />
                                    </div>
                                ))}
                            </div>




                            <div className='grid grid-cols-3 gap-3 py-6 border-t border-gray-100 mt-4'>
                                {[{ icon: <FaBalanceScale />, label: t.longerExpiry }, { icon: <FaTruck />, label: t.fastDelivery }, { icon: <FaQrcode />, label: t.qrVerified }].map((item, idx) => (
                                    <div key={idx} className='flex flex-col items-center gap-2 text-center group transition-all hover:-translate-y-1'><div className='bg-white shadow-md text-[#00b259] p-4 rounded-[20px] group-hover:bg-[#00b259] group-hover:text-white transition-all duration-500 ring-1 ring-gray-50'>{React.cloneElement(item.icon, { size: 22 })}</div><span className='text-[9px] font-black text-[#143d2c] uppercase tracking-widest'>{item.label}</span></div>
                                ))}
                            </div>
                        </div>

                        {/* RIGHT: DETAILS SECTION */}
                        <div className='lg:w-1/2 flex flex-col gap-5 custom-scrollbar max-h-[1100px] overflow-y-auto px-1.5 lg:pl-3 lg:pr-6 pt-2'>
                            {loading ? (
                                <div className='flex flex-col gap-6 animate-pulse'><div className='h-10 bg-slate-50 w-3/4 rounded-2xl'></div><div className='h-16 bg-slate-50 w-full rounded-3xl'></div><div className='h-8 bg-slate-50 w-1/4 rounded-2xl'></div><div className='h-40 bg-slate-50 w-full rounded-4xl'></div></div>
                            ) : (
                                <>
                                    <div className='flex flex-col gap-3'>
                                        <div className='flex items-center gap-3'>
                                            <span className='bg-[#00b259]/10 text-[#00b259] px-3 py-1 rounded-full text-[11px] font-black uppercase tracking-wider'>{p?.category}</span>
                                            <div className='h-1 w-1 bg-gray-300 rounded-full'></div>
                                            <span className='text-gray-400 text-[11px] font-bold uppercase tracking-widest'>{p?.brandName}</span>
                                        </div>
                                        <h1 className='text-[#143d2c] text-xl lg:text-3xl font-black leading-tight tracking-tight uppercase'>
                                            {p?.productName}
                                        </h1>

                                        <div className='flex items-center gap-3 mt-0.5'>
                                            <div className='flex items-center bg-[#143d2c] text-white px-2 py-0.5 rounded text-[13px] font-black gap-1 shadow-md'>
                                                {data?.rating || '5.0'} <FaStar size={10} className='text-[#ffc107]' />
                                            </div>
                                            <div className='flex items-center gap-1'>

                                                <div className='flex text-[#ffc107]'><FaStar size={12} /><FaStar size={12} /><FaStar size={12} /><FaStar size={12} /><FaStar size={12} className='text-gray-200' /></div>
                                                <span className='text-gray-400 text-[12px] font-black pl-2 border-l border-gray-100 ml-2'>({data?.ratings?.length || 0} Verified Ratings)</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='bg-gradient-to-br from-white to-[#f8fcfb] border border-gray-50 rounded-[32px] p-5 shadow-xl shadow-green-50/50 flex flex-col gap-4 relative overflow-hidden'>
                                        <div className='absolute -right-10 -top-10 w-32 h-32 bg-[#00b259]/5 rounded-full blur-3xl'></div>
                                        <div className='flex items-end gap-5'>
                                            <span className='text-3xl lg:text-4xl font-black text-[#1a1a1a] tracking-tighter'>{displayINRCurrency(currentSellingPrice)}</span>
                                            <div className='flex flex-col pb-1'>
                                                <span className='text-xl text-gray-300 line-through font-bold'>{displayINRCurrency(currentMRP)}</span>
                                                {currentMRP > currentSellingPrice && (
                                                    <div className='inline-flex items-center gap-1 text-[#00b259] bg-[#00b259]/10 px-3 py-1.5 rounded-xl text-[13px] font-black uppercase tracking-widest border border-[#00b259]/20 shadow-sm'>
                                                        {t.save} {displayINRCurrency(currentMRP - currentSellingPrice)}
                                                    </div>
                                                )}
                                            </div>
                                            {currentMRP > currentSellingPrice && (
                                                <div className='bg-[#ffc107] text-white text-[14px] font-black px-4 py-2 rounded-2xl ml-auto shadow-lg rotate-2 mb-2'>
                                                    {Math.round(((currentMRP - currentSellingPrice) / currentMRP) * 100)}% {t.off}
                                                </div>
                                            )}
                                        </div>

                                        <div className='flex flex-col gap-3'>
                                            <div className='flex items-center gap-3 text-gray-500 text-sm font-bold'>
                                                <MdVerifiedUser className='text-[#00b259]' size={20} />
                                                <span>{t.qualityGuaranteed}</span>
                                            </div>

                                            {/* Toxicity & Composition Card */}
                                            <div className='bg-white border border-gray-200 rounded-2xl p-4 shadow-sm flex items-center justify-between gap-4 group/tox transition-all hover:border-[#00b259]/30'>
                                                <div className='flex flex-col gap-1.5 flex-1'>
                                                    <div className='flex items-center gap-2'>
                                                        <div className='text-[#143d2c] opacity-80'>
                                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10 2v8L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45L14 10V2" /><path d="M8.5 2h7" /><path d="M7 16h10" /></svg>
                                                        </div>
                                                        <span className='text-[15px] font-black text-[#143d2c] tracking-tight'>{t.ingredients}</span>
                                                    </div>
                                                    <div className='flex flex-col'>
                                                        <p className='text-[14px] text-gray-700 font-bold leading-tight'>
                                                            {p?.ingredients || p?.formulation || (t.technicalDetails || 'Technical Content Details')}
                                                        </p>
                                                        <span className={`text-[10px] font-black uppercase tracking-wider mt-1 ${activeTox.textColor}`}>{activeTox.label}</span>
                                                    </div>
                                                </div>

                                                {/* Diamond Toxicity Label */}
                                                <div className='relative w-16 h-16 flex items-center justify-center shrink-0'>
                                                    <div className='w-12 h-12 rotate-45 border-2 border-gray-800 relative overflow-hidden bg-white shadow-sm'>
                                                        {/* Top Triangle */}
                                                        <div className='absolute top-0 left-0 w-full h-1/2 flex items-center justify-center bg-white'>
                                                            <span className='-rotate-45 text-[6px] font-black text-gray-800' style={{ fontSize: '5px' }}>{activeTox.warning}</span>
                                                        </div>
                                                        {/* Bottom Triangle */}
                                                        <div className={`absolute bottom-0 left-0 w-full h-1/2 ${tox.bg}`}></div>
                                                    </div>
                                                    {/* Code circle overlay */}
                                                    <div className='absolute -bottom-1 -right-1 bg-white border border-gray-200 w-5 h-5 rounded-full flex items-center justify-center shadow-sm z-10'>
                                                        <span className='text-[8px] font-black text-gray-800'>{tox.code}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* User Address Display (If logged in and address exists) */}
                                            {(user?.id || user?._id) && (user?.village || user?.city || user?.pincode) && (
                                                <div className='bg-[#f4fbf7] border border-[#00b259]/20 rounded-2xl p-4 shadow-sm flex items-center gap-4 transition-all animate-fadeIn'>
                                                    <div className='bg-[#00b259] text-white p-2.5 rounded-xl shadow-md'>
                                                        <FaTruck size={18} />
                                                    </div>
                                                    <div className='flex flex-col gap-0.5'>
                                                        <p className='text-[10px] font-black text-[#00b259] uppercase tracking-[2px]'>{t.deliveringTo}</p>
                                                        <p className='text-[13px] font-bold text-[#143d2c]'>
                                                            {[user?.village, user?.city, user?.pincode].filter(Boolean).join(', ')}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>



                                    {variants.length > 0 && (
                                        <div className='flex flex-col gap-5'>
                                            <div className='flex items-center justify-between'>
                                                <span className='text-[#143d2c] font-black text-[15px] uppercase tracking-[3px]'>{t.selectSize}</span>
                                                <span
                                                    onClick={() => setIsSizeGuideModalOpen(true)}
                                                    className='text-[#00b259] text-[11px] font-black underline cursor-pointer hover:text-[#143d2c] transition-colors'
                                                >
                                                    {t.sizeGuide}
                                                </span>
                                            </div>
                                            <div className='grid grid-cols-2 md:grid-cols-3 gap-3 lg:gap-4'>
                                                {variants.map(v => (
                                                    <div key={v.id} onClick={() => setSelectedVariant(v.id)} className={`relative border-2 rounded-2xl p-2.5 lg:p-4 cursor-pointer transition-all duration-300 flex flex-col gap-0.5 items-center justify-center ${selectedVariant === v.id ? 'border-[#00b259] bg-[#f4fbf7] shadow-lg ring-2 ring-green-100/50 scale-[1.02]' : 'border-gray-100 bg-white hover:border-gray-200 hover:shadow-md'}`}>
                                                        {v.discount !== (t.bestPrice || 'Best Price') ? (
                                                            <span className='absolute -top-2.5 left-0 right-0 mx-auto w-fit bg-[#00b259] text-white text-[8px] lg:text-[9px] font-black px-3 py-1 rounded-full shadow-lg z-10 uppercase tracking-wider animate-pulse'>{v.discount}</span>
                                                        ) : (
                                                            v.bestSeller && <span className='absolute -top-2.5 left-0 right-0 mx-auto w-fit bg-[#6f42c1] text-white text-[8px] lg:text-[9px] font-black px-3 py-1 rounded-full shadow-lg z-10 uppercase'>{t.bestSeller}</span>
                                                        )}
                                                        <span className='text-[#143d2c] font-black text-[14px] lg:text-[16px]'>{v.size}</span>
                                                        <span className='text-[#1a1a1a] font-bold text-[13px] lg:text-[14px] opacity-80'>{displayINRCurrency(v.price)}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* PRE-CART SUMMARY (Total Price Calculation) */}
                                    {/* <div className='bg-[#f4fbf7] border border-[#00b259]/10 rounded-2xl p-4 mt-2 flex flex-col gap-3 shadow-sm'>
 <FaMinus size={10} />
 </button>
 <span className='w-6 text-center font-black text-sm text-[#143d2c]'>{localQuantity}</span>
 <button
 onClick={() => setLocalQuantity(prev => prev + 1)}
 className='w-8 h-8 rounded-lg bg-[#00b259] flex items-center justify-center text-white shadow-md hover:brightness-110 transition-all active:scale-90'
 >
 <FaPlus size={10} />
 </button>
 </div>
 </div>
 </div> */}

                                    <div className='flex flex-col lg:flex-row items-center gap-4 mt-6 sticky bottom-4 bg-white/95 lg:bg-transparent backdrop-blur-md lg:backdrop-blur-none p-3 lg:p-0 rounded-[24px] shadow-2xl lg:shadow-none z-30 lg:relative border border-gray-100 lg:border-none'>
                                        {isInCart ? (
                                            <div className='flex gap-3 lg:gap-4 w-full'>
                                                <button
                                                    className='relative overflow-hidden w-full h-14 lg:h-16 bg-white border border-[#143d2c] text-[#143d2c] rounded-[16px] lg:rounded-[20px] uppercase font-black tracking-[1px] lg:tracking-[2px] leading-none flex items-center justify-center select-none group'
                                                    onClick={() => setShowCart(true)}
                                                >
                                                    <div className='absolute -bottom-[50%] left-0 w-full h-full bg-[#143d2c] origin-bottom transition-transform duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] -skew-y-[9.3deg] scale-y-0 group-hover:scale-y-[2] z-0'></div>
                                                    <span className='relative z-10 transition-all duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] group-hover:text-white flex items-center gap-3 text-[13px] lg:text-[15px] group-hover:-translate-y-8 group-hover:opacity-0'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5 lg:w-6 lg:h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                                        </svg>
                                                        {t.goToCart} →
                                                    </span>
                                                    <span className='absolute top-[50%] left-[50%] -translate-x-[50%] translate-y-[150%] opacity-0 z-20 text-white transition-all duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] group-hover:-translate-y-[50%] group-hover:opacity-100 flex items-center justify-center gap-3 text-[13px] lg:text-[15px] w-full'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5 lg:w-6 lg:h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                                        </svg>
                                                        {t.goToCart} →
                                                    </span>
                                                </button>
                                            </div>
                                        ) : (
                                            <>
                                                <button className='relative overflow-hidden w-full lg:flex-1 h-14 lg:h-16 bg-white border border-[#f39200] text-[#f39200] rounded-[16px] lg:rounded-[20px] uppercase font-black tracking-[1px] lg:tracking-[2px] leading-none flex items-center justify-center select-none group shadow-md' onClick={handleAddToCart}>
                                                    <div className='absolute -bottom-[50%] left-0 w-full h-full bg-[#f39200] origin-bottom transition-transform duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] -skew-y-[9.3deg] scale-y-0 group-hover:scale-y-[2] z-0'></div>
                                                    <span className='relative z-10 transition-all duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] group-hover:text-white flex items-center gap-3 text-[13px] lg:text-[15px] group-hover:-translate-y-8 group-hover:opacity-0'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5 lg:w-6 lg:h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                                                        </svg>
                                                        {t.addToCart}
                                                    </span>
                                                    <span className='absolute top-[50%] left-[50%] -translate-x-[50%] translate-y-[150%] opacity-0 z-20 text-white transition-all duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] group-hover:-translate-y-[50%] group-hover:opacity-100 flex items-center justify-center gap-3 text-[13px] lg:text-[15px] w-full'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5 lg:w-6 lg:h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                                                        </svg>
                                                        {t.addToCart}
                                                    </span>
                                                </button>
                                                <button className='relative overflow-hidden w-full lg:flex-1 h-14 lg:h-16 bg-white border border-[#28a745] text-[#28a745] rounded-[16px] lg:rounded-[20px] uppercase font-black tracking-[1px] lg:tracking-[2px] leading-none flex items-center justify-center select-none group shadow-md' onClick={(e) => handleBuyProduct(e, data?._id)}>
                                                    <div className='absolute -bottom-[50%] left-0 w-full h-full bg-[#28a745] origin-bottom transition-transform duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] -skew-y-[9.3deg] scale-y-0 group-hover:scale-y-[2] z-0'></div>
                                                    <span className='relative z-10 transition-all duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] group-hover:text-white flex items-center gap-3 text-[13px] lg:text-[15px] group-hover:-translate-y-8 group-hover:opacity-0'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5 lg:w-6 lg:h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                                        </svg>
                                                        {t.buyNow}
                                                    </span>
                                                    <span className='absolute top-[50%] left-[50%] -translate-x-[50%] translate-y-[150%] opacity-0 z-20 text-white transition-all duration-[600ms] ease-[cubic-bezier(0.48,0,0.12,1)] group-hover:-translate-y-[50%] group-hover:opacity-100 flex items-center justify-center gap-3 text-[13px] lg:text-[15px] w-full'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5 lg:w-6 lg:h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                                        </svg>
                                                        {t.buyNow}
                                                    </span>
                                                </button>
                                            </>
                                        )}
                                    </div>


                                </>
                            )}
                        </div>
                    </div>
                </div>


                {/* FULL WIDTH OVERVIEW AND DESCRIPTION */}
                {/* REDESIGNED DETAILS SECTION (MATCHING REFERENCE IMAGE) */}
                <div className='mt-12 bg-white rounded-3xl p-6 lg:p-10 shadow-sm border border-gray-100 overflow-hidden'>
                    {/* Overview Section */}
                    <div className='mb-12'>
                        <h3 className='flex items-center gap-3 mb-6'>
                            <div className='section-bullet'></div>
                            {t.overview}
                        </h3>

                        <div className='overflow-hidden rounded-2xl border border-gray-100 shadow-sm'>
                            <table className='w-full text-left text-[14px] border-collapse'>
                                <tbody>
                                    {[
                                        { label: t.productName, val: p?.productName },
                                        { label: t.brand, val: p?.brandName },
                                        { label: t.category, val: p?.category },
                                        // { label: t.subCategory, val: p?.subcategory_name },
                                    ].map((item, idx) => (
                                        <tr key={idx} className={idx % 2 !== 0 ? 'bg-[#f8faf9]' : 'bg-white'}>
                                            <td className='py-4 px-6 font-bold text-[#143d2c] w-1/3 border-r border-gray-50/50'>{item.label}</td>
                                            <td className='py-4 px-6 text-gray-600 font-semibold'>{item.val || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Product Description Section */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className='pt-8 border-t border-gray-50'
                    >
                        <h3 className='mb-10'>{t.aboutProduct}</h3>


                        <div className='space-y-12 max-w-5xl'>
                            {/* ABOUT PRODUCT */}
                            <div className='relative'>
                                <h3 className='text-[11px] font-black text-gray-400 uppercase tracking-[3px] mb-6 flex items-center gap-3'>
                                    <div className='w-6 h-[2px] bg-[#00b259]'></div>
                                    {t.productDescription}
                                </h3>
                                <div className='space-y-5 pl-2'>
                                    {p?.description ? p.description.split('\n').filter(s => s.trim()).map((line, idx) => (
                                        <div key={idx} className='flex gap-4 items-start group'>
                                            <div className='w-1.5 h-1.5 bg-[#00b259] mt-2 shrink-0 rounded-full group-hover:scale-150 transition-transform'></div>
                                            <p className='text-gray-600 text-[15px] leading-relaxed font-medium group-hover:text-black transition-colors'>
                                                {line.trim()}
                                            </p>
                                        </div>
                                    )) : (
                                        <div className='flex gap-4 items-start'>
                                            <div className='w-1.5 h-1.5 bg-[#00b259] mt-2 shrink-0 rounded-full'></div>
                                            <p className='text-gray-600 text-[15px] font-medium italic'>Detailed description for this product is coming soon.</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* SPECIFICATIONS */}
                            <div>
                                <h3 className='text-[11px] font-black text-gray-400 uppercase tracking-[3px] mb-6 flex items-center gap-3'>
                                    <div className='w-6 h-[2px] bg-[#00b259]'></div>
                                    {t.specifications}
                                </h3>
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-5 pl-2'>
                                    {[
                                        // { label: t.ingredients, val: p?.ingredients },
                                        { label: t.chemicalComposition, val: p?.chemical_composition },
                                        { label: t.formulation, val: p?.formulation },
                                        { label: t.targetPest, val: p?.targetPest },
                                        { label: t.recommendedDosage, val: p?.recommended_dosage },
                                        { label: t.dosage, val: p?.dosage },
                                        { label: t.suitableCrops, val: p?.suitableCrops },
                                        { label: t.technicalName, val: p?.technicalName },
                                        // { label: t.nutritionalFacts, val: p?.nutritional_value },
                                        { label: t.safetyPrecautions, val: p?.safetyPrecautions }
                                    ].map((spec, idx) => (
                                        <div key={idx} className='flex gap-4 items-start group pb-3 border-b border-gray-50 last:border-0 md:last:border-b'>
                                            <div className='w-1.5 h-1.5 bg-gray-200 mt-2 shrink-0 group-hover:bg-[#00b259] transition-colors'></div>
                                            <div className='flex flex-col'>
                                                <span className='text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1'>{spec.label}</span>
                                                <p className='text-gray-700 text-[14px] leading-tight font-bold group-hover:text-[#00b259] transition-colors'>
                                                    {spec.val || "-"}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className='mt-10'
                >
                    <VerticalCardProduct category={data?.category} heading={translatedSimilarHeading} />
                </motion.div>



                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className='mt-10 mb-12'
                >
                    <VerticalCardProduct category={data?.category} heading={p?.category ? `${p.category}'s Best Sellers` : "Farmer's Best Sellers"} />
                </motion.div>

                {/* BOTTOM SECTION: 3-COLUMN LAYOUT (SUMMARY | REVIEWS | FAQ) */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className='mt-10 pt-8 border-t border-gray-100'
                >
                    <div className='grid grid-cols-1 lg:grid-cols-12 gap-8'>

                        {/* COLUMN 1: CUSTOMER REVIEWS SUMMARY */}
                        <div className='lg:col-span-3 flex flex-col gap-6 bg-white p-6 rounded-2xl border border-gray-100 h-fit'>
                            <h4 className='border-b border-gray-50 pb-4 uppercase tracking-tighter'>{t.customerReviews}</h4>

                            <div className='flex items-center gap-3 mt-2'>
                                <div className='flex text-[#ffc107]'><FaStar size={16} /><FaStar size={16} /><FaStar size={16} /><FaStar size={16} /><FaStar size={16} className='text-gray-200' /></div>
                                <span className='bg-black text-white text-xs font-bold px-2 py-0.5 rounded'>4.38</span>
                            </div>
                            <p className='text-gray-400 text-sm'>{t.verifiedCommunityRatings}</p>

                            <div className='flex flex-col gap-3 mt-4'>
                                {[
                                    { s: 5, p: 90 }, { s: 4, p: 8 }, { s: 3, p: 2 }, { s: 2, p: 0 }, { s: 1, p: 0 }
                                ].map(item => (
                                    <div key={item.s} className='flex items-center gap-4 text-gray-600'>
                                        <span className='text-xs font-bold w-12'>{item.s} {t.star}</span>
                                        <div className='flex-1 h-2 bg-gray-100 rounded-full overflow-hidden'>
                                            <div className='h-full bg-[#00b259]' style={{ width: `${item.p}%` }}></div>
                                        </div>
                                        <span className='text-[10px] font-bold w-8 text-right'>{item.p}%</span>
                                    </div>
                                ))}
                            </div>


                        </div>

                        {/* COLUMN 2: INDIVIDUAL REVIEWS */}
                        <div className='lg:col-span-5 flex flex-col gap-4'>
                            <h4 className='px-2 uppercase tracking-tighter'>{t.topVerified}</h4>
                            <div className='flex flex-col gap-4'>
                                {translatedReviews.map((item, idx) => (
                                    <motion.div
                                        key={item.id}
                                        initial={{ opacity: 0, x: -20 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: idx * 0.1 }}
                                        className='bg-white p-6 rounded-2xl border border-gray-100 flex flex-col gap-3 hover:shadow-md transition-all'
                                    >
                                        <div className='flex items-center gap-4'>
                                            <div className='bg-[#e8f5ed] text-[#00b259] p-2.5 rounded-full'>
                                                <FaRegUserCircle size={24} />
                                            </div>
                                            <div className='flex flex-col'>
                                                <span className='text-[#1a1a1a] font-bold text-sm'>{item.user}</span>
                                                {item.sub && <span className='text-gray-400 text-[11px] font-medium leading-none'>{item.sub}</span>}
                                                <div className='flex items-center gap-1 text-[#00b259] text-[10px] font-bold uppercase mt-0.5 tracking-tight'>
                                                    <FaCheckCircle size={10} />
                                                    {t.verifiedFarmer}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='flex items-center gap-4 mt-1'>
                                            <div className='flex text-[#f39200]'><FaStar size={13} /><FaStar size={13} /><FaStar size={13} /><FaStar size={13} /><FaStar size={13} className='text-gray-200' /></div>
                                            <span className='text-gray-400 text-[11px] font-semibold tracking-tight'>{t.reviewedOn} {item.date}</span>
                                        </div>
                                        {item.comment && <p className='text-gray-600 text-sm mt-1 leading-relaxed'>{item.comment}</p>}
                                    </motion.div>
                                ))}
                            </div>
                        </div>

                        {/* COLUMN 3: FREQUENTLY ASKED QUESTIONS */}
                        <div className='lg:col-span-4 flex flex-col gap-0 bg-white rounded-2xl border border-gray-100 py-6 overflow-hidden h-fit'>
                            <div className='px-6 mb-6'>
                                <span className='bg-[#ea5532] text-white px-4 py-1.5 font-bold text-lg rounded shadow-md italic tracking-tight block w-fit'>
                                    {t.productFaqs}
                                </span>
                            </div>

                            <div className='flex flex-col'>
                                {translatedFaqs.map((faq, index) => (
                                    <div key={index} className='border-b border-gray-50 last:border-0'>
                                        <button
                                            className='w-full px-6 py-4 flex items-center justify-between text-left group hover:bg-gray-50/50 transition-colors'
                                            onClick={() => toggleFaq(index)}
                                        >
                                            <span className='text-[13px] font-bold text-gray-700 leading-snug pr-4 transition-colors group-hover:text-[#00b259]'>{faq.question}</span>
                                            <div className='text-gray-400 min-w-[20px]'>
                                                {activeFaq === index ? <FaMinus size={12} /> : <FaPlus size={12} />}
                                            </div>
                                        </button>
                                        <AnimatePresence>
                                            {activeFaq === index && (
                                                <motion.div
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: 'auto', opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    className='overflow-hidden'
                                                >
                                                    <div className='px-6 pb-6'>
                                                        <p className='text-[12px] text-gray-500 font-medium leading-relaxed bg-[#f8fcf9] p-4 rounded-xl border border-[#eef5ef]'>{faq.answer}</p>
                                                    </div>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>



            {/* SIZE GUIDE MODAL */}
            <AnimatePresence>
                {isSizeGuideModalOpen && (
                    <div className='fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm' onClick={() => setIsSizeGuideModalOpen(false)}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9, y: 20 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.9, y: 20 }}
                            className='bg-white w-full max-w-lg rounded-[2.5rem] overflow-hidden shadow-2xl relative'
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className='bg-[#00b259]/10 p-8 pb-10 relative'>
                                <button
                                    onClick={() => setIsSizeGuideModalOpen(false)}
                                    className='absolute top-6 right-6 p-2 rounded-full bg-white/50 hover:bg-white transition-all'
                                >
                                    <MdClose size={20} className='text-[#143d2c]' />
                                </button>
                                <div className='flex items-center gap-4 mb-2'>
                                    <div className='bg-white p-3 rounded-2xl shadow-sm'>
                                        <FaBalanceScale size={20} className='text-[#00b259]' />
                                    </div>
                                    <h3 className='text-2xl font-black text-[#143d2c] uppercase tracking-tight'>{t.sizeGuide}</h3>
                                </div>
                                <p className='text-[#00b259] font-bold text-sm tracking-wide'>{t.sizeGuideHeader}</p>
                            </div>

                            <div className='p-8 -mt-6 bg-white rounded-t-[2.5rem] relative z-10'>
                                <div className='space-y-6'>
                                    <div className='overflow-hidden rounded-2xl border border-gray-100 shadow-sm'>
                                        <table className='w-full text-left text-[13px] border-collapse'>
                                            <thead>
                                                <tr className='bg-[#f8faf9]'>
                                                    <th className='py-4 px-6 font-black text-[#143d2c] uppercase tracking-widest'>{t.unit}</th>
                                                    <th className='py-4 px-6 font-black text-[#143d2c] uppercase tracking-widest'>{t.application}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[
                                                    { unit: 'KG / GM', app: t.solidsDesc },
                                                    { unit: 'LT / ML', app: t.liquidsDesc },
                                                    { unit: 'Packet', app: t.seedsDesc },
                                                    { unit: 'Acre / Hectare', app: t.coverageDesc }
                                                ].map((item, idx) => (
                                                    <tr key={idx} className='border-t border-gray-50'>
                                                        <td className='py-4 px-6 font-bold text-gray-700'>{item.unit}</td>
                                                        <td className='py-4 px-6 text-gray-500'>{item.app}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='bg-blue-50 p-5 rounded-2xl border border-blue-100 flex gap-4'>
                                        <FaInfoCircle className='text-blue-500 shrink-0 mt-1' size={18} />
                                        <p className='text-[12px] text-blue-700 leading-relaxed font-medium'>
                                            {t.sizeInfoDesc}
                                        </p>
                                    </div>
                                </div>

                                <button
                                    onClick={() => setIsSizeGuideModalOpen(false)}
                                    className='w-full mt-8 bg-[#143d2c] hover:bg-[#00b259] text-white font-black py-4 rounded-2xl transition-all shadow-xl active:scale-95 uppercase tracking-[3px] text-xs'
                                >
                                    {t.gotIt}
                                </button>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

        </motion.div >

    )
}

export default ProductDetails